export { default as OfficeBuildingOutlineIcon } from './OfficeBuildingOutlineIcon';
